import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Components
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import About from "@/components/About";
import Services from "@/components/Services";
import CaseStudies from "@/components/CaseStudies";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppWidget from "@/components/WhatsAppWidget";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const [stats, setStats] = useState(null);
  const [services, setServices] = useState([]);
  const [caseStudies, setCaseStudies] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statsRes, servicesRes, casesRes, testimonialsRes, faqRes] = await Promise.all([
          fetch(`${API}/stats`),
          fetch(`${API}/services`),
          fetch(`${API}/case-studies`),
          fetch(`${API}/testimonials`),
          fetch(`${API}/faq`)
        ]);

        const [statsData, servicesData, casesData, testimonialsData, faqData] = await Promise.all([
          statsRes.json(),
          servicesRes.json(),
          casesRes.json(),
          testimonialsRes.json(),
          faqRes.json()
        ]);

        setStats(statsData);
        setServices(servicesData);
        setCaseStudies(casesData);
        setTestimonials(testimonialsData);
        setFaq(faqData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F1419]">
        <div className="flex flex-col items-center gap-4">
          <div className="spinner" data-testid="loading-spinner"></div>
          <p className="text-[#8B949E]">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0F1419]" data-testid="homepage">
      <Navbar />
      <main>
        <Hero stats={stats} />
        <Stats stats={stats} />
        <About />
        <Services services={services} />
        <CaseStudies caseStudies={caseStudies} />
        <Testimonials testimonials={testimonials} />
        <FAQ faqData={faq} />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
      <WhatsAppWidget />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
